import { mobileViewMax } from './util';

const windowWidth = window.innerWidth;
const descriptionMarginHandler = (() => {
    if (windowWidth < mobileViewMax) {
        const faqHeaderImage = document.querySelector('.js-faq-header__image');
        const faqHeaderDescription = document.querySelector('.faq-header--mobile .js-faq-header__description');
        faqHeaderDescription.style.marginTop = `${faqHeaderImage.offsetHeight}px`;
    }
});

// init the FAQ
const initChatFaq = (() => {
    const locale = $('.conversational-wrapper').data('locale');
    window.seamly = window.seamly || [];
    window.seamly.push({
        action: 'init',
        args: {
            parentElement: document.querySelector('.conversational-wrapper .conversational-placeholder'),
            layoutMode: 'window',
            defaults: {
                visible: 'minimized',
            },
            locale,
        },
    });
})();

// init the chat
const initAccordionFaq = (() => {
    let locale = $('.conversational-wrapper').data('locale');
    window.seamlyFaqTree = window.seamlyFaqTree || [];

    const usedLanguage = locale.split('-')[0].trim().toLowerCase();

    // if usedLanguage is 'en' script requires 'en-en' as locale
    if (usedLanguage === 'en') {
        locale = 'en-en';
    }

    window.seamlyFaqTree.push({
        action: 'init',
        args: {
            parentElement: document.querySelector('.seamly-faq-placeholder'),
            locale,
        },
    });
})();

// pushing messages Seamly needs directly to them
const liveChatEvent = (name, message) => {
    window.seamly.push({
        action: 'setTopic',
        args: {
            name,
            fallbackMessage: message,
        },
    });
};

// trigger for buttons that need to open the chat window from outside
const openChatWindow = () => {
    window.seamly.push({
        action: 'setVisibility',
        args: 'open',
    });
};

// bind buttons
document.buttonSendMessage = () => {
    openChatWindow();

    window.seamly = window.seamly || [];
    const locale = $('.conversational-wrapper').data('locale');
    const usedLanguage = locale.split('-')[0].trim().toUpperCase();
    const name = 'Click_email_button';
    let message = '';
    switch (usedLanguage) {
        case 'NL':
            message = 'Hi, ik ben Ruby! wat kan ik voor je doen';
            liveChatEvent(name, message);
            break;
        case 'FR':
            message = "Bonjour, je suis Ruby. le chatbot de Basic-Fit. je peux t'aider pour quelque chose?";
            liveChatEvent(name, message);
            break;
        case 'ES':
            message = 'Hola, soy Ruby. En qué puedo ayudarte?';
            liveChatEvent(name, message);
            break;
        case 'DE':
            message = 'Hallo, ich bin Ruby! Bevor ich Ihnen besser helfen kann, habe ich eine Frage?';
            liveChatEvent(name, message);
            break;
        default:
            message = "Hi, I'm Ruby! what can I do for you";
            liveChatEvent(name, message);
            break;
    }
};

document.buttonLiveChat = () => {
    openChatWindow();

    window.seamly = window.seamly || [];
    const locale = $('.conversational-wrapper').data('locale');
    const usedLanguage = locale.split('-')[0].trim().toUpperCase();
    let name = '';
    let message = '';
    switch (usedLanguage) {
        case 'NL':
            name = 'Click_livechat_button';
            message = 'Hi, ik ben Ruby! wat kan ik voor je doen';
            liveChatEvent(name, message);
            break;
        case 'FR':
            name = 'Start_Je_veux_discuter_';
            message = "Bonjour, je suis Ruby. le chatbot de Basic-Fit. je peux t'aider pour quelque chose?";
            liveChatEvent(name, message);
            break;
        case 'ES':
            name = 'Click_quiero_chatear_button';
            message = 'Hola, soy Ruby. En qué puedo ayudarte?';
            liveChatEvent(name, message);
            break;
        case 'DE':
            name = 'Click_livechat_button';
            message = 'Hallo, ich bin Ruby! Bevor ich Ihnen besser helfen kann, habe ich eine Frage?';
            liveChatEvent(name, message);
            break;
        default:
            name = 'Click_livechat_button';
            message = "Hi, I'm Ruby! what can I do for you";
            liveChatEvent(name, message);
            break;
    }
};

// see if we landed here with a question in the URL
const checkForQuestionInUrl = () => {
    const { hash } = window.location;

    if (hash.startsWith('#!question=')) {
        let urlQuestion = hash.split('#!question=')[1];

        // replace + with spaces
        urlQuestion = decodeURIComponent(urlQuestion).replace(/\+/g, ' ');

        window.seamly.push({
            action: 'setVisibility',
            args: 'open',
        });

        window.seamly.push({
            action: 'askText',
            args: urlQuestion,
        });
    }
};

// moving the chat to a different position then the default injection spot (for sake of scrolling behavior)
const moveChatPosition = () => {
    const targetNode = document.body; // let's wait for that thing to be written/injected in here, and move it where we want it
    const observerConfig = { childList: true, subtree: true };

    const observer = new MutationObserver((mutations, obs) => {
        const chatPlaceholder = document.getElementById('seamly-placeholder');
        if (chatPlaceholder) {
            $('.main-content').append(chatPlaceholder);
            obs.disconnect();
            // after the move, let's see if we got here through a search
            checkForQuestionInUrl();
        }
    });

    observer.observe(targetNode, observerConfig);
};

export default (() => {
    $(document).ready(() => {
        moveChatPosition();
        initChatFaq();
        initAccordionFaq();
    });
    $(window).on('resize', descriptionMarginHandler(windowWidth));
})();
